import { render, staticRenderFns } from "./AssessorOrder.vue?vue&type=template&id=5a3e43bc&"
import script from "./AssessorOrder.vue?vue&type=script&lang=js&"
export * from "./AssessorOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports